import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Answers, UserInfo } from '../types';

interface AssessmentContextType {
  answers: Answers;
  setAnswer: (questionId: string, score: number) => void;
  resetAssessment: () => void;
  isComplete: boolean;
  setIsComplete: (complete: boolean) => void;
  userInfo: UserInfo | null;
  setUserInfo: (info: UserInfo) => void;
}

const AssessmentContext = createContext<AssessmentContextType | undefined>(undefined);

export const AssessmentProvider = ({ children }: { children: ReactNode }) => {
  const [answers, setAnswers] = useState<Answers>({});
  const [isComplete, setIsComplete] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const setAnswer = (questionId: string, score: number) => {
    setAnswers(prev => ({ ...prev, [questionId]: score }));
  };

  const resetAssessment = () => {
    setAnswers({});
    setIsComplete(false);
    setUserInfo(null);
  };

  return (
    <AssessmentContext.Provider value={{ answers, setAnswer, resetAssessment, isComplete, setIsComplete, userInfo, setUserInfo }}>
      {children}
    </AssessmentContext.Provider>
  );
};

export const useAssessmentContext = () => {
  const context = useContext(AssessmentContext);
  if (context === undefined) {
    throw new Error('useAssessmentContext must be used within an AssessmentProvider');
  }
  return context;
};
